"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Constants = void 0;
var Constants;
(function (Constants) {
    Constants["MqttTopicFormat"] = "trailer/v2/%s/%s";
    Constants["IdField"] = "id";
    Constants["StateField"] = "s";
    Constants["TimestampField"] = "ts";
    Constants["TypeField"] = "t";
    Constants["FieldField"] = "f";
    Constants["ValueField"] = "v";
    Constants["MessageField"] = "m";
    Constants["ErrorField"] = "e";
    Constants["ProgressField"] = "p";
    Constants["UpdateTypeField"] = "ut";
    Constants["SourceField"] = "so";
    Constants["NameField"] = "n";
    Constants["DeviceField"] = "d";
    Constants["LevelField"] = "l";
    Constants["OnField"] = "o";
    Constants["UrlField"] = "u";
    Constants["ShasumField"] = "ss";
    Constants["SeqStateField"] = "sn";
    Constants["Connected"] = "c";
    Constants["Intended"] = "i";
    Constants["DataField"] = "da";
    Constants["ActionField"] = "a";
    Constants["LastSeenField"] = "ls";
    Constants["LatitudeField"] = "lat";
    Constants["LongitudeField"] = "lon";
    Constants["TimezoneField"] = "tz";
    Constants["ApplyImmediatelyField"] = "ai";
    Constants["MqttTopicField"] = "to";
    Constants["SsidField"] = "si";
    Constants["PasswordField"] = "pw";
    Constants["UpdatedAtField"] = "ua";
    Constants["StageField"] = "sg";
    Constants["AcknowledgedField"] = "ack";
})(Constants = exports.Constants || (exports.Constants = {}));
//# sourceMappingURL=Constants.js.map